'use client';

import React from 'react';

import { Box, BoxProps } from '../box';

export interface ListProps extends BoxProps {
  /** List style type */
  styleType?: 'none' | 'disc' | 'circle' | 'square' | 'decimal';
  /** List position */
  stylePosition?: 'inside' | 'outside';
  /** Spacing between items */
  spacing?: number | string;
}

/**
 * List component for rendering ordered or unordered lists
 */
export const List: React.FC<ListProps> = ({
  as = 'ul',
  styleType = 'disc',
  stylePosition = 'outside',
  spacing = 2,
  children,
  ...boxProps
}) => {
  return (
    <Box
      as={as}
      listStyleType={styleType}
      listStylePosition={stylePosition}
      paddingLeft={stylePosition === 'outside' ? 6 : 0}
      {...boxProps}
    >
      {React.Children.map(children, (child, index) => {
        if (React.isValidElement(child) && child.type === ListItem) {
          return React.cloneElement(child as React.ReactElement<Record<string, unknown>>, {
            marginBottom: index < React.Children.count(children) - 1 ? spacing : 0,
          });
        }
        return child;
      })}
    </Box>
  );
};

export type ListItemProps = BoxProps;

/**
 * ListItem component for individual list items
 */
export const ListItem: React.FC<ListItemProps> = ({ as = 'li', children, ...boxProps }) => {
  return (
    <Box as={as} {...boxProps}>
      {children}
    </Box>
  );
};

export default List;
